module.exports = __webpack_public_path__ + "img/22.37a64aa1.jpg";